import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-1 flex flex-col leading-none text-right" }
const _hoisted_2 = ["data-dusk"]

import { Worklist } from '@/models';
import { usePathwayName } from '@/composables/pathways';
import NavDropdownButton from '@/lib/components/Navigation/NavDropdownButton.vue';
import { BasePopover, PopoverLink } from '@/lib/components/Popover';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useToKebabCase } from '@/composables/stringUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutPopover',
  props: {
    name: null,
    isDropDownActive: { type: Boolean },
    pathways: null,
    organisationId: null,
    text: null,
    usePathwayNameComposable: { type: Boolean },
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
    name: string;
    isDropDownActive: boolean;
    pathways: Worklist[];
    organisationId: string;
    text: string;
    usePathwayNameComposable?: boolean;
    redirectTo: string;
  };



const route = useRoute();
const selectedPathway = computed(() =>
  props.pathways?.find(
    (pathway: Worklist) => pathway.slug === route.params.pathway
  )
);

const redirectLink = (pathwaySlug: string) => {
  const link = {
    name: props.redirectTo,
    params: {}
  };

  if (props.redirectTo === 'virtual-ward-redirect') {
    link.params = {
      organisationId: props.organisationId
    };
  } else {
    link.params = {
      pathway: pathwaySlug
    };
  }

  return link;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BasePopover), {
    ref: __props.name,
    position: "right",
    class: "mx-5"
  }, {
    button: _withCtx(() => [
      _createVNode(NavDropdownButton, {
        "is-active": __props.isDropDownActive,
        "is-open": !!_ctx.$refs?.name?.isOpen,
        "icon-colour": __props.isDropDownActive ? '' : 'text-gray-400',
        "data-dusk": `${_unref(useToKebabCase)(__props.name)}-nav-btn`
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", {
              class: _normalizeClass(["group-focus:text-dark-500 group-focus:border-gray-400 flex items-center font-semibold group h-full", {
              'text-dark-500': __props.isDropDownActive,
              'text-gray-400': !__props.isDropDownActive,
            }]),
              "data-dusk": `current-${_unref(useToKebabCase)(__props.name)}-name`
            }, _toDisplayString(__props.text), 11, _hoisted_2)
          ])
        ]),
        _: 1
      }, 8, ["is-active", "is-open", "icon-colour", "data-dusk"])
    ]),
    menu: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pathways, (pathway) => {
        return (_openBlock(), _createBlock(_unref(PopoverLink), {
          key: pathway.id,
          active: _unref(selectedPathway)?.slug === pathway.slug,
          "data-dusk": `${_unref(useToKebabCase)(__props.name)}-${pathway?.id}`,
          to: redirectLink(pathway.slug),
          class: "block min-w-40",
          style: {"width":"unset"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.usePathwayNameComposable ? _unref(usePathwayName)(pathway.slug) : pathway.name), 1)
          ]),
          _: 2
        }, 1032, ["active", "data-dusk", "to"]))
      }), 128))
    ]),
    _: 1
  }, 512))
}
}

})